module.exports = __webpack_public_path__ + "img/2.771d91f8.jpg";